import axios from "axios";

const API_PATH = '/manage/device';

const FetchSource = async searches => (
	await axios.get(API_PATH, { params: searches })
);

const FetchStatisticSource = async searches => (
	await axios.get(`${API_PATH}/statistic`, { params: searches })
);

const CreateDeviceType = async source => (
	await axios.post(API_PATH, source)
);

const RemoveDeviceType = async dtId => (
	await axios.delete(`${API_PATH}/${dtId}`)
);

const EditDeviceType= async ({ dtId, source }) => (
	await axios.put(`${API_PATH}/${dtId}`, source)
);

export { FetchSource, FetchStatisticSource, CreateDeviceType, RemoveDeviceType, EditDeviceType } ;
